// Centralized site configuration.
export const SITE = {
  name: "Dr. Sandrey Miranda Nobre",
  shortName: "Dr. Sandrey Nobre",
  subtitle: "Odontólogo Perito Judicial",
  fullTitle:
    "Cirurgião-Dentista · Perito Judicial Odontológico · Assistente Técnico Judicial",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/2fhygl37_WhatsApp_Image_2026-06-01_at_11.35.03-removebg-preview.png",
  // WhatsApp number with country code, only digits.
  whatsappNumber: "5538999059959",
  whatsappDisplay: "(38) 99905-9959",
  whatsappMessage:
    "Olá Dr. Sandrey, gostaria de obter informações sobre uma perícia odontológica.",
  email: "contato@drsandreynobre.com.br",
  cro: "CRO 29.826",
  city: "Atendimento em todo o Brasil",
  instagram: "https://instagram.com/",
  linkedin: "https://linkedin.com/",
};

export const whatsappLink = (customMessage) => {
  const text = encodeURIComponent(customMessage || SITE.whatsappMessage);
  return `https://wa.me/${SITE.whatsappNumber}?text=${text}`;
};
